import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import utils from "../../utils/utils";
import { dispatch } from "../index";

const initialState = {
  error: null,
  equipments: [],
  equipmentsObject: [],
  totalPages: 1,
  loading: false,
  limit: 10,
  currentPage: 1,
};

const slice = createSlice({
  name: "equipment",
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    startLoading(state, action) {
      state.loading = true;
    },
    stopLoading(state, action) {
      state.loading = false;
    },
    getSuccess(state, action) {
      const data = action.payload.data;
      state.equipments = utils.sortAlphatically(data, "name");
      state.equipmentsObject = utils.getUniqueObject(data, "PK");
      const total = action.payload.totalItems;
      let pages = Math.floor(total / state.limit);
      const remainder = total % state.limit;
      if (remainder !== 0) {
        pages += 1;
      }
      state.totalPages = pages;
      state.loading = false;
    },
    addSuccess(state, action) {
      state.loading = false;
    },
    editSuccess(state, action) {
      state.loading = false;
    },
    deleteSuccess(state, action) {
      state.loading = false;
      state.equipments = state.equipments.filter(
        (item) => item.PK !== action.payload.PK
      );
    },
    setCurrentPage(state, action) {
      console.log(action.payload);
      state.currentPage = action.payload;
    },
  },
});

export default slice.reducer;

export function startLoading() {
  return async () => {
    dispatch(slice.actions.startLoading());
  };
}

export function stopLoading() {
  return async () => {
    dispatch(slice.actions.stopLoading());
  };
}

export function getEquipments() {
  return async () => {
    try {
      const result = await axios.get(`/equipments?size=1000`);
      dispatch(slice.actions.getSuccess(result.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addEquipment(data, callback) {
  return async () => {
    try {
      const result = await axios.post(`/equipments`, data);
      callback(result.data.data.PK);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function editEquipment(id, data, callback) {
  return async () => {
    try {
      const result = await axios.put(`/equipments/${id}`, data);
      callback();
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteEquipment(id = "") {
  return async () => {
    try {
      const result = await axios.delete(`/equipments/${id}`);
      dispatch(slice.actions.deleteSuccess(result.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setCurrentPage(page) {
  return async () => {
    dispatch(slice.actions.setCurrentPage(page));
  };
}
